module.exports = __webpack_public_path__ + "static/fonts/PostGrotesk-Book.23fc369b.woff";